import { useState } from "react";
import "./style.css";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";
import { useLanguage } from "../../context/LanguageContext";

const Header = () => {
  const [click, setClick] = useState(false);
  const { t, language, toggleLanguage } = useLanguage();

  const handleClick = () => setClick(!click);
  const closeMenu = () => setClick(false);

  return (
    <header className="header">
      <nav className="navbar">
        <Link
          to="intro"
          spy={true}
          smooth={true}
          offset={-90}
          duration={700}
          onClick={closeMenu}
          className="logo"
        >
          B
        </Link>
        <div className="nav-right">
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <Link
                activeClass="scrollActive"
                to="intro"
                spy={true}
                smooth={true}
                offset={-90}
                duration={700}
                onClick={closeMenu}
              >
                {t("header.home")}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                activeClass="scrollActive"
                to="about"
                spy={true}
                smooth={true}
                offset={-90}
                duration={700}
                onClick={closeMenu}
              >
                {t("header.about")}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                activeClass="scrollActive"
                to="resume"
                spy={true}
                smooth={true}
                offset={-90}
                duration={700}
                onClick={closeMenu}
              >
                {t("header.resume")}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                activeClass="scrollActive"
                to="portfolio"
                spy={true}
                smooth={true}
                offset={-90}
                duration={700}
                onClick={closeMenu}
              >
                {t("header.portfolio")}
              </Link>
            </li>
            <li className="nav-item">
              <Link
                activeClass="scrollActive"
                to="certificates"
                spy={true}
                smooth={true}
                offset={-90}
                duration={700}
                onClick={closeMenu}
              >
                {t("header.certificates")}
              </Link>
            </li>
          </ul>
          <div className="lang-switch" role="radiogroup" aria-label="Language">
            <div
              className={`lang-indicator ${language === "tr" ? "right" : ""}`}
            />
            <button
              className={`lang-btn ${language === "en" ? "active" : ""}`}
              onClick={() => language !== "en" && toggleLanguage()}
              aria-checked={language === "en"}
            >
              EN
            </button>
            <button
              className={`lang-btn ${language === "tr" ? "active" : ""}`}
              onClick={() => language !== "tr" && toggleLanguage()}
              aria-checked={language === "tr"}
            >
              TR
            </button>
          </div>
          <div className="hamburger" onClick={handleClick}>
            {click ? (
              <FaTimes style={{ color: "#ffffff" }} />
            ) : (
              <FaBars style={{ color: "#ffffff" }} />
            )}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
